import React, { useState } from 'react';
import { Message, Accordion, List, Icon, Label, Button } from 'semantic-ui-react';
const { Title: AccordionTitle, Content: AccordionContent } = Accordion;
const { Item: ListItem, Icon: ListIcon, Content: ListContent, Header: ListHeader, Description: ListDescription } = List;
import { filter } from 'ramda';
const ValidationMessages = ({ validationResult, onClear, clearingInProgress }) => {
    const [validationAccordionIndex, setValidationAccordionIndex] = useState(-1);
    let validationResults = validationResult?.fieldValidations || {};
    //Filter correct validations
    validationResults = filter((result) => result.type !== "correct", validationResults);
    const handleValidationAccordionClick = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = validationAccordionIndex === index ? -1 : index;
        setValidationAccordionIndex(newIndex);
    };
    const getValidationIcon = (status) => {
        switch (status) {
            case 'error':
                return 'exclamation triangle';
            case 'warning':
                return 'warning circle';
            default:
                return 'info circle';
        }
    };
    const getValidationColor = (status) => {
        switch (status) {
            case 'error':
                return 'red';
            case 'warning':
                return 'orange';
            default:
                return 'blue';
        }
    };
    if (!Object.keys(validationResults).length) {
        return null;
    }
    const hasErrors = validationResult?.status === "error";
    return (React.createElement(Message, { error: hasErrors },
        React.createElement(Accordion, { fluid: true, styled: true },
            React.createElement(AccordionTitle, { active: validationAccordionIndex === 0, index: 0, onClick: handleValidationAccordionClick, style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement(Icon, { name: "dropdown" }),
                    React.createElement(Icon, { name: hasErrors ? 'exclamation triangle' : 'warning circle', color: hasErrors ? 'red' : 'orange' }),
                    "Validation Issues Found (",
                    Object.keys(validationResults).length,
                    ")",
                    React.createElement(Label, { size: "small", color: hasErrors ? 'red' : 'orange', style: { marginLeft: '8px' } }, hasErrors ? 'Errors' : 'Warnings')),
                onClear && (React.createElement(Button, { size: "mini", color: "grey", loading: clearingInProgress, disabled: clearingInProgress, onClick: (e) => {
                        e.stopPropagation(); // Prevent accordion toggle
                        onClear();
                    }, style: { marginLeft: '8px' } },
                    React.createElement(Icon, { name: "close" }),
                    "Clear All"))),
            React.createElement(AccordionContent, { active: validationAccordionIndex === 0 },
                React.createElement(List, { divided: true, relaxed: true }, Object.values(validationResults).map((result, index) => (React.createElement(ListItem, { key: index },
                    React.createElement(ListIcon, { name: getValidationIcon(result.type), color: getValidationColor(result.type), size: "large", verticalAlign: "middle" }),
                    React.createElement(ListContent, null,
                        React.createElement(ListHeader, null,
                            React.createElement("small", { className: `ui ${getValidationColor(result.type)} text` }, result.errorCode?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || result.type)),
                        React.createElement(ListDescription, null,
                            React.createElement("small", null, result.question),
                            result.fieldPath && (React.createElement("div", null,
                                React.createElement(Label, { size: "mini", color: "grey" },
                                    "Field: ",
                                    result.fieldPath)))))))))))));
};
export default ValidationMessages;
